import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { LanguageService } from '@core/services/language';

@Component({
  selector: 'app-languageswitcher',
  imports: [CommonModule],
  templateUrl: './languageswitcher.html',
  styleUrl: './languageswitcher.scss',
})
export class Languageswitcher {
  private readonly languageService = inject(LanguageService);
  @ViewChild('languageWrapper') languageWrapper!: ElementRef;

  languageDropdown = false;
  closePanel(): void {
    this.languageDropdown = false;
  }
  toggleLanguage(): void {
    this.languageDropdown = !this.languageDropdown;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.languageDropdown && this.languageWrapper && !this.languageWrapper.nativeElement.contains(event.target)) {
      this.languageDropdown = false;
    }
  }

  switchLanguage(language: string): void {
    this.languageService.setLanguage(language);
    this.languageDropdown = false;
  }
}